import type { Product, QuoteProductFee } from '@features/products/types/products.types';

type StoredFee = QuoteProductFee & { vatRate?: unknown };

const parseFraction = (value: unknown): number | null => {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }
    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
};

const normaliseFee = (fee: StoredFee): QuoteProductFee => {
    const { vatRate, ...rest } = fee;
    if (vatRate === undefined) {
        return fee;
    }
    const fraction = parseFraction(vatRate);
    if (fee.vatRatePercent != null || fraction === null) {
        return rest;
    }
    return { ...rest, vatRatePercent: Math.round(fraction * 10000) / 100 };
};

export const normaliseLegacyFeeVat = (product: Product): Product => {
    if (!product || !Array.isArray(product.fees)) {
        return product;
    }
    return { ...product, fees: product.fees.map(normaliseFee) };
};
